import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { useSelector } from "react-redux";
import { getMenuItems } from "../helpers/Menu";
import { LayoutTypes } from "../constants/layout";
import AppMenu from "./Menu";

const UserBox = () => {
  const profileImg = process.env.REACT_APP_USER_PROFILE_IMAGE_URL;
  const ProfileMenus = [
    // {
    //   label: "My Account",
    //   icon: "fe-user",
    //   redirectTo: "#",
    // },
    {
      label: "Settings",
      icon: "fe-settings",
      redirectTo: "General-Settings",
    },
    {
      label: "Lock Screen",
      icon: "fe-lock",
      redirectTo: "/auth/lock-screen",
    },
    {
      label: "Logout",
      icon: "fe-log-out",
      redirectTo: "/auth/logout",
    },
  ];

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <div className="user-box text-center">
      <img
        src={profileImg}
        alt=""
        title="Mat Helme"
        className="rounded-circle avatar-md"
      />
      <Dropdown show={dropdownOpen} onToggle={toggleDropdown}>
        <Dropdown.Toggle
          id="dropdown-notification"
          as="a"
          onClick={toggleDropdown}
          className="cursor-pointer text-dark h5 mt-2 mb-1 d-block"
        >
          Geneva Kennedy
        </Dropdown.Toggle>
        <Dropdown.Menu className="user-pro-dropdown">
          <div onClick={toggleDropdown}>
            {(ProfileMenus || []).map((item, index) => (
              <Link
                to={item.redirectTo}
                className="dropdown-item notify-item"
                key={index + "-profile-menu"}
              >
                <i className={`${item.icon} me-1`}></i>
                <span>{item.label}</span>
              </Link>
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>
      <p className="text-muted">Admin Head</p>
    </div>
  );
};

// const SideBarContent = () => {
//   return (
//     <>
//       <UserBox />
//       <AppMenu menuItems={getMenuItems()} />
//       <div className="clearfix" />
//     </>
//   );
// };

const SideBarContent = () => {
  const { AuthReducer: { auth } }= useSelector((state) => state);
  return (
    <>
      <UserBox />
      <AppMenu menuItems={auth?.menuData} />
      <div className="clearfix" />
    </>
  );
};

const LeftSidebar = ({ isCondensed = false, hideLogo = true }) => {
  const menuNodeRef = useRef(null);
  const logoSm = process.env.REACT_APP_LOGO_DARK_URL;
  const logoDark = process.env.REACT_APP_LOGO_DARK_URL;
  const logoDark2 = process.env.REACT_APP_LOGO_DARK_URL;
  const logoLight = process.env.REACT_APP_LOGO_LIGHT_URL;
  const logoLight2 = process.env.REACT_APP_LOGO_LIGHT_URL;

  const { layoutType } = useSelector((state) => ({
    layoutType: state.layoutReducer.layoutType,
    leftSideBarType: state.layoutReducer.leftSideBarType,
  }));

  const handleOtherClick = (e) => {
    if (
      menuNodeRef &&
      menuNodeRef.current &&
      !menuNodeRef.current.contains(e.target)
    ) {
      document.body.classList.remove("sidebar-enable");
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOtherClick, false);
    return () => {
      document.removeEventListener("mousedown", handleOtherClick, false);
    };
  }, []);
  
  return (
    <React.Fragment>
      <div className="app-menu" ref={menuNodeRef}>
        {!hideLogo && (
          <div className="logo-box">
            <Link to="/" className="logo logo-dark text-center">
              <span className="logo-sm">
                <img src={logoSm} alt="" height="70" />
              </span>
              <span className="logo-lg">
                <img
                  src={
                    layoutType === LayoutTypes.LAYOUT_TWO_COLUMN
                      ? logoDark2
                      : logoDark
                  }
                  alt=""
                  height="70"
                />
              </span>
            </Link>
            <Link to="/" className="logo logo-light text-center">
              <span className="logo-sm">
                <img src={logoSm} alt="" height="70" />
              </span>
              <span className="logo-lg">
                <img
                  src={
                    layoutType === LayoutTypes.LAYOUT_TWO_COLUMN
                      ? logoLight2
                      : logoLight
                  }
                  alt=""
                  height="70"
                />
              </span>
            </Link>
          </div>
        )}

        {!isCondensed ? (
          <SimpleBar className="scrollbar show h-100" scrollbarMaxSize={320}>
            <SideBarContent />
          </SimpleBar>
        ) : (
          <SideBarContent />
        )}
      </div>
    </React.Fragment>
  );
};

export default LeftSidebar;
